export type Direction = 'positive' | 'negative' | 'unchanged';

/**
 * Classifies a number (typically a difference) as positive, negative, or
 * unchanged. Shared by components that color financial movement — green for
 * up, red for down, gray for flat.
 */
export function directionOf(value: number): Direction {
  if (value > 0) {
    return 'positive';
  }
  if (value < 0) {
    return 'negative';
  }
  return 'unchanged';
}

/**
 * Inline text color for a direction (no background): green up, red down,
 * gray flat. Matches the `value`-type styling of the Indicator component.
 */
export const DIRECTION_TEXT_CLASS: Record<Direction, string> = {
  positive: 'text-positive-fg-alt',
  negative: 'text-negative-fg-alt',
  unchanged: 'text-unchanged-fg-alt',
};

/**
 * Screen-reader wording for a direction, standing in for the arrow icon and
 * color that convey it visually.
 */
export const DIRECTION_LABEL: Record<Direction, string> = {
  positive: 'Increase',
  negative: 'Decrease',
  unchanged: 'No change',
};
